import { render, staticRenderFns } from "./addPersonEditNew.vue?vue&type=template&id=efba2cce&scoped=true"
import script from "./addPersonEditNew.vue?vue&type=script&lang=js"
export * from "./addPersonEditNew.vue?vue&type=script&lang=js"
import style0 from "./addPersonEditNew.vue?vue&type=style&index=0&id=efba2cce&prod&lang=scss&scoped=true"
import style1 from "./addPersonEditNew.vue?vue&type=style&index=1&id=efba2cce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efba2cce",
  null
  
)

export default component.exports